import {
  StatusDeclinedIcon,
  StatusPendingIcon,
  StatusSignedIcon,
} from "@/shared/assets/svg/icons";

export const RecordStatusTypes = {
  NEW: "NEW",
  AWAITING_SIGNATURE: "AWAITING_SIGNATURE",
  DECLINED: "DECLINED",
  SIGNED: "SIGNED",
  REJECTED: "REJECTED",
  RETURNED_TO_WORK: "RETURNED_TO_WORK",
} as const;

export type RecordStatus =
  (typeof RecordStatusTypes)[keyof typeof RecordStatusTypes];

export const statusIcons = {
  NEW: null,
  AWAITING_SIGNATURE: <StatusPendingIcon />,
  DECLINED: <StatusDeclinedIcon />,
  SIGNED: <StatusSignedIcon />,
  REJECTED: <StatusDeclinedIcon />,
};
